export default "__VITE_ASSET__jXzkHjO3__"